import { ShipmentStatus } from '../enums/ShipmentStatus';
import { TransportMode } from '../enums/TransportMode';
import { Shipment } from '../types/Shipment';

export const emptyShipment: Shipment = {
  transportMode: TransportMode.Air,
  status: ShipmentStatus.Booked,
};
